import React, { createContext, useContext, useEffect } from "react" 
import { Outlet, useParams, useNavigate } from "react-router-dom"
import { Plus } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { CollectionLoader, UnitTitleBlock } from "lib/components"
import { Design } from "." 

const DesignContext = createContext({})
export const useDesignCtx = () => useContext(DesignContext)

export default function DesignProvider({ className="" }:{ className?:string }){
  const navigate = useNavigate()
  const { desid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()
  
  const { data:_Designs } = queryTools.resource.parseQueryForApi("design.findAll", {})
  const { data:_Design } = queryTools.resource.parseQueryForApi("design.findById", { _id: desid }, { enabled: !!desid })
  const saveFn = queryTools.resource.save(["design.all"])
  
  const saveDesign = (data:any) => {
    saveFn.mutate({ resource: "Design", data } )
  }

  return (
    <DesignContext.Provider value={{ }}>
      <div className={cn("w-full pt-6", className)}>
        <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="Design manager">
          <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" onClick={saveDesign} />
        </UnitTitleBlock>

        <div className="w-full flex items-stretch gap-4">
          
          <div className="w-2/12 flex items-stretch border border-solid border-slate-700 h-[40rem] overflow-auto scrollbar">
            <CollectionLoader 
              collection={_Designs}
              selectFn={(item:any) => navigate(`/design/${item._id}`)}
              selectProp="_id"
              labelProp="name"
              className="w-full"
            />
          </div>

          <div className="w-10/12">
            { _Design !== undefined && ( <Design /> )}
          </div>

        </div>
    
      </div>
    </DesignContext.Provider>
  )
}